export const CONFIG = {
  WS_URL: import.meta.env.VITE_WS_URL,
  API_URL: import.meta.env.VITE_API_URL,
  AGENCY_ID: import.meta.env.VITE_REGENT_AGENCY_ID || 1,
  ENV_MODE: import.meta.env.MODE,
  GOOGLE_KEY: import.meta.env.VITE_GOOGLE_KEY,
  /**
   * Key SOLO para la API de mapas embebidos (iframe), restringida por dominio.
   * Separada de `GOOGLE_KEY` a propósito: esa habilita la JS API y la Static
   * API, que se facturan por carga; la embebida es gratuita sin límite y no
   * necesita ninguna de las otras.
   */
  MAPS_EMBED_KEY: import.meta.env.VITE_GOOGLE_MAPS_EMBED_KEY,
};
